const e = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
    <path fill="currentColor" fill-rule="evenodd"
        d="M7 2C5.89543 2 5 2.89543 5 4V5H9V4C9 2.89543 8.10457 2 7 2ZM3 4V5C2.17159 5.00002 1.50003 5.67158 1.50003 6.5V12.5C1.50003 13.3284 2.1716 14 3.00003 14H11C11.8285 14 12.5 13.3284 12.5 12.5V6.5C12.5 5.67157 11.8285 5 11 5H11V4C11 1.79086 9.20914 0 7 0C4.79086 0 3 1.79086 3 4ZM7.00003 10.75C7.69039 10.75 8.25003 10.1904 8.25003 9.5C8.25003 8.80964 7.69039 8.25 7.00003 8.25C6.30967 8.25 5.75003 8.80964 5.75003 9.5C5.75003 10.1904 6.30967 10.75 7.00003 10.75Z"
        clip-rule="evenodd"></path>
</svg>`;
export {
  e as default
};
